export default {"src":"/_next/static/media/disney_plus.bfd9e41f.svg","height":40,"width":40};